import gsap, { Quad } from 'gsap'
import ScrollMagic from '../../libs/scrollmagic/uncompressed/ScrollMagic'

export default class Header {
    constructor(element) {
        this.el = element
        this.init()
    }

    init() {
        this.logoAnimation()
        this.burgerAnimation()
        this.hideTabsOnScroll()
        this.toggleLoginMenu()
        this.toggleMobileSubMenu()
        this.toggleLoginOverlayMenu()
    }

    hideTabsOnScroll() {
        const headerContainer = this.el;
        let lastScroll = 0;

        window.addEventListener("scroll", () => {
            const currentScroll = window.pageYOffset;
            if (currentScroll <= 0) {
                headerContainer.classList.remove("scroll-up");
                return;
            }

            if (currentScroll > lastScroll && !headerContainer.classList.contains("scroll-down")) {
                // down
                headerContainer.classList.remove("scroll-up");
                headerContainer.classList.add("scroll-down");
            } else if (
                currentScroll < lastScroll &&
                headerContainer.classList.contains("scroll-down")
            ) {
                // up
                headerContainer.classList.remove("scroll-down");
                headerContainer.classList.add("scroll-up");
            }
            lastScroll = currentScroll;
        })
    }

    logoAnimation() {
        const logoContainer = this.el;
        const bodyContainer = document.querySelector("main");

        const controller = new ScrollMagic.Controller({ loglevel: 2 });

        if (logoContainer) {
            var scene = new ScrollMagic.Scene({
                triggerElement: bodyContainer,
                triggerHook: 'onLeave',
                offset: 200
            })
                .on('enter', function () {
                    shrinkMenuClass();
                })
                .on('leave', function () {
                    shrinkMenuClass();
                })
                .addTo(controller);


            var shrinkMenuClass = function () {
                logoContainer.classList.toggle('small');
            }
        }
    }

    burgerAnimation() {
        //Create timeline and get logo circle
        var controlit = this.el.querySelector("#burger");
        var menuToggle = gsap.timeline({ paused: true, reversed: true });
        menuToggle
            /*
            .set('', {className:"-=closemenu"})
            .set('', {className:"+=openmenu"})
            */
            // .to(' .top', { duration: .2, y: '-9px', transformOrigin: '50% 50%' }, 'burg')
            // .to(' .bot', { duration: .2, y: '9px', transformOrigin: '50% 50%' }, 'burg')
            // .to(' .mid', { duration: .2, scale: 0.1, transformOrigin: '50% 50%' }, 'burg')
            // .add('rotate')
            // .to(' .top', { duration: .2, y: '5' }, 'rotate')
            // .to(' .bot', { duration: .2, y: '-5' }, 'rotate')
            // .to(' .top', { duration: .2, rotationZ: 45, transformOrigin: '50% 50%' }, 'rotate')
            // .to(' .bot', { duration: .2, rotationZ: -45, transformOrigin: '50% 50%' }, 'rotate')
        // .set('#burger .mid', {opacity:0})//temp fix for stupid iOS rotate y bug


        if (controlit) {
            controlit.onclick = function () {
                menuToggle.reversed() ? menuToggle.restart() : menuToggle.reverse();

            };
        }

        const moveButton = document.querySelector('.navigation-burger');
        const subnavigationContainer = document.querySelector('#sub-navigation');
        const items = [...document.querySelectorAll('.menu__item')];
        const openmobile = document.querySelectorAll('.openmenu');
        const closemobile = document.querySelectorAll('.closemenu');
        
        const root = document.body;
        const headerContainer = this.el;
        let isMoved = false;

        if (moveButton) {
            moveButton.onclick = function () {
                // toggle flag
                isMoved = !isMoved;
                const loginOverlay = document.querySelector('#sub-login-navigation');
                const closeIcon = document.querySelector('.close-mobile-login-icon');
                const loginIcon = document.querySelector('.login-mobile-icon');
                const chatIframe = document.querySelector('[data-hj-allow-iframe]');
                if (loginOverlay) {
                    loginOverlay.classList.remove('active');
                    closeIcon.classList.remove('mobile-hidden')
                    closeIcon.classList.add('mobile-hidden');
                    loginIcon.classList.remove('mobile-hidden');
                }

                if (isMoved) {
                    
                    root.classList.add('menuOpen');
                    headerContainer.classList.remove("scroll-down")
                    headerContainer.classList.add("scroll-up")
                    subnavigationContainer.classList.add('menuOpen');
                    openmobile.forEach((item) => {
                        
                        item.classList.add('mobile-hidden');
                        item.classList.remove('mobile-shown');
                        if(chatIframe !== null)
                            chatIframe.style.visibility = 'hidden';
                        
                    });
                    closemobile.forEach((item) => {
                        
                        item.classList.remove('mobile-hidden');
                        item.classList.add('mobile-shown');
                        if(chatIframe !== null)
                        chatIframe.style.visibility = 'visible';
                    });
                }
                else {
                    root.classList.remove('menuOpen');
                    subnavigationContainer.classList.remove('menuOpen');
                    openmobile.forEach((item) => {
                        
                        item.classList.remove('mobile-hidden');
                        item.classList.add('mobile-shown');
                        if(chatIframe !== null)
                        chatIframe.style.visibility = 'hidden';
                    });
                    closemobile.forEach((item) => {
                        
                        item.classList.add('mobile-hidden');
                        item.classList.remove('mobile-shown');
                        if(chatIframe !== null)
                        chatIframe.style.visibility = 'visible';
                    });
                }



                items.forEach((item, index) => {
                    setTimeout(() => {
                        item.classList.toggle('is-moved')
                    }, index * 30);
                });
            };
        }
    }

    toggleLoginMenu() {
        const headerContainer = this.el;
        const loginMenuItem = headerContainer.querySelector('.login')

        if (!loginMenuItem) return;

        const outerContainer = loginMenuItem.querySelector('.login-menu')
        const innerContainerHeight = loginMenuItem.querySelector('.login-menu__inner').offsetHeight

        loginMenuItem.addEventListener('mouseover', (e) => {
            loginMenuItem.classList.add("show-menu")
            outerContainer.style.height = innerContainerHeight + 'px'
        })

        loginMenuItem.addEventListener('mouseleave', (e) => {
            loginMenuItem.classList.remove("show-menu")
            outerContainer.style.height = '0px'
        })
    }

    toggleLoginOverlayMenu(){
        const loginButton = document.querySelector('.login-mobile');
        const loginOverlay = document.querySelector('#sub-login-navigation');
        const closeIcon = document.querySelector('.close-mobile-login-icon');
        const loginIcon = document.querySelector('.login-mobile-icon');

        console.log(loginButton, loginOverlay, closeIcon, loginIcon);
        
        if (!loginButton) return;

        loginButton.addEventListener('click', (e) => {
            //e.preventDefault();
            const chatIframe = document.querySelector('[data-hj-allow-iframe]');
            loginOverlay.classList.toggle('active');
            closeIcon.classList.toggle('mobile-hidden');
            loginIcon.classList.toggle('mobile-hidden');
            if(chatIframe !== null){
                if(chatIframe.style.visibility === 'hidden') {
                    chatIframe.style.visibility = 'visible';
                } else {
                    chatIframe.style.visibility = 'hidden';
                }
            }
        });
    }

    toggleMobileSubMenu() {
        const toggleSubmenuButtons = document.querySelectorAll('.expand-submenu');
        toggleSubmenuButtons.forEach((button) => {
            button.addEventListener('click', (e) => { 
                e.preventDefault();
                let ul = button.parentElement.nextElementSibling.closest('.submenu-mobile-dropdown-list');
                ul.classList.toggle('active');
                button.classList.toggle('active');
            });
        });
    }
}